const diet = {
  state: {
    isloading: false
  },
  mutations: {
    'SET_ISLOADING': function (state, isloading) {
      state.isloading = isloading
    }
  },
  actions: {
    setIsLoading ({
      commit,
      state
    }, isloading) {
      return commit('SET_ISLOADING', isloading)
    }
  }
}

export default diet
